import { render, staticRenderFns } from "./modal_upload.vue?vue&type=template&id=772b684c&scoped=true"
import script from "./modal_upload.vue?vue&type=script&lang=js"
export * from "./modal_upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b684c",
  null
  
)

export default component.exports